// extracted by mini-css-extract-plugin
export default {"listCard":"DraggableCards__list-card___3F97b","dragHandle":"DraggableCards__drag-handle___MsmoI"};